import { CampaignId } from 'mini-campaign-bootstrap/lib/schema/CampaignId';
import { ME_CONTROL_FALLBACK_ID } from 'mini-mecontrol/lib/utils/constants';
import { onSignal } from 'listeners/lib/signalTrackerListener';
import {
    DELETE_OR_CANCEL_EVENT_CLICKED_FROM_MAIL,
    ME_CONTROL_EXPANDED,
    RSVP_EVENT_COMPLETE,
} from 'mini-app-constants/lib/commonEventSignalConstants';
import {
    FOLDER_CHANGED,
    MAIL_LIST_SCROLLED_3_TIMES,
} from 'mini-mail-workflow-tracking/lib/constants/ListViewWorkflowConstants';
import {
    CLOSE_READING_PANE,
    DELETE_CONVERSATION_END,
    DELETE_MAIL_END,
} from 'mini-mail-workflow-tracking/lib/constants/ReadingPaneWorkflowConstants';

type CustomRules = Partial<Record<CampaignId, () => Promise<boolean>>>;

export const getMailSurfaceCampaignCustomRules = (): CustomRules => {
    const customRules: CustomRules = {};
    customRules[CampaignId.MiniSearchAllModulesInfrequentUsers] = async () => {
        await Promise.race([
            onSignal(DELETE_OR_CANCEL_EVENT_CLICKED_FROM_MAIL),
            onSignal(RSVP_EVENT_COMPLETE),
        ]);
        return true;
    };
    customRules[CampaignId.MiniMailSearchInfrequentUsers] = async () => {
        await Promise.race([onSignal(FOLDER_CHANGED), onSignal(MAIL_LIST_SCROLLED_3_TIMES)]);
        return true;
    };
    customRules[CampaignId.LiteInAppReview] = async () => {
        await Promise.race([
            onSignal(CLOSE_READING_PANE),
            onSignal(DELETE_CONVERSATION_END),
            onSignal(DELETE_MAIL_END),
        ]);
        return true;
    };
    customRules[CampaignId.MeControlAddEmailAccounts] = async () =>
        Promise.resolve(!document?.getElementById(ME_CONTROL_FALLBACK_ID));
    customRules[CampaignId.MeControlSignOut] = async () => {
        await onSignal(ME_CONTROL_EXPANDED);
        return true;
    };
    return customRules;
};
